import { api } from "./api";

export interface OverviewStats {
  totalUsers: number;
  totalCourses: number;
  totalEnrollments: number;
  totalRevenue: number;
  userGrowth: number;
  courseGrowth: number;
  enrollmentGrowth: number;
  revenueGrowth: number;
}

export interface UserAnalytics {
  roleDistribution: { role: string; count: number }[];
  verifiedUsers: number;
  activeUsers: number;
  newUsersLast30Days: number;
  usersOverTime: { date: string; count: number }[];
}

export interface CourseAnalytics {
  totalCourses: number;
  publishedCourses: number;
  draftCourses: number;
  archivedCourses: number;
  averageRating: number;
  totalEnrollments: number;
  coursesOverTime: { date: string; count: number }[];
  topCourses: { _id: string; title: string; enrollments: number }[];
}

export interface RevenueAnalytics {
  totalRevenue: number;
  monthlyRevenue: { month: string; revenue: number }[];
  revenueByCourse: { course: string; revenue: number }[];
  revenueGrowth: number;
}

export interface EnrollmentAnalytics {
  totalEnrollments: number;
  completedEnrollments: number;
  inProgressEnrollments: number;
  completionRate: number;
  enrollmentsOverTime: { date: string; count: number }[];
}

export const analyticsApi = {
  getOverview: (timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: OverviewStats }>(`/analytics/overview${params}`);
  },

  getDashboard: (timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: any }>(`/analytics/dashboard${params}`);
  },

  getUserStats: (timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: UserAnalytics }>(`/analytics/users${params}`);
  },

  getCourseStats: (courseId: string, timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: CourseAnalytics }>(`/analytics/courses/${courseId}${params}`);
  },

  getRevenueStats: (timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: RevenueAnalytics }>(`/analytics/revenue${params}`);
  },

  getContentStats: (timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: any }>(`/analytics/content${params}`);
  },

  getMentorshipStats: (timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: any }>(`/analytics/mentorship${params}`);
  },

  getEnrollmentTrends: (timeRange?: string) => {
    const params = timeRange ? `?timeRange=${timeRange}` : "";
    return api.get<{ success: boolean; data: Array<{ _id: string; enrollments: number; completed: number; active: number }> }>(`/analytics/enrollment-trends${params}`);
  },
};